import "../google_maps_loader.js";

window.Sparkle ??= {};
window.Sparkle.Views ??= {};

Sparkle.Views.GoogleMap = class GoogleMap {
  constructor(options) {
    this.lazyLoad = this.lazyLoad.bind(this);
    this.load = this.load.bind(this);
    this.initializeMap = this.initializeMap.bind(this);
    this.createMapBounds = this.createMapBounds.bind(this);
    this.resizeMap = this.resizeMap.bind(this);
    this.adjustToBounds = this.adjustToBounds.bind(this);
    this.hidePOI = this.hidePOI.bind(this);
    this.createInfoWindow = this.createInfoWindow.bind(this);
    this.displayInfoWindowOnClick = this.displayInfoWindowOnClick.bind(this);
    this.infoWindowTemplate = this.infoWindowTemplate.bind(this);
    if (options == null) {
      options = {};
    }
    this.I18n = {
      directions: Sparkle.t("directions"),
    };

    this.el = options.el ? jQuery(options.el)[0] : jQuery("<div>")[0];

    // If options.el does not exist, do not attempt to load the map
    if (!this.el) {
      return;
    }

    if (options.lazy) {
      this.lazyLoad();
    } else {
      this.load();
    }
  }

  lazyLoad() {
    if (!IntersectionObserver) {
      return this.load();
    } // IE fallback

    var mapObserver = new IntersectionObserver((entries) => {
      // If isIntersecting is false, the target is out of view and we do not need to do anything
      if (!entries[0].isIntersecting) {
        return;
      }

      // Ensure we don't double load if multiple intersection events are queued before we call `disconnect`
      if (this.lazyTriggered) {
        return;
      }

      this.lazyTriggered = true;
      mapObserver.disconnect();

      return this.load();
    });

    return mapObserver.observe(this.el);
  }

  load() {
    return Sparkle.GoogleMaps.load(this.initializeMap);
  }

  initializeMap() {
    this.createMapBounds();
    this.mapObject = new google.maps.Map(this.el, Sparkle.GoogleMaps.defaultMapOptions());
    this.hidePOI();
    this.addMarkersToMap();
    return this.resizeMap();
  }

  createMapBounds() {
    return (this.bounds = new google.maps.LatLngBounds());
  }

  resizeMap() {
    return google.maps.event.addListenerOnce(this.mapObject, "tilesloaded", () => this.adjustToBounds());
  }

  adjustToBounds() {
    const map = this.mapObject;
    map.fitBounds(this.bounds);

    // Don't zoom in so much that the user can't get a sense of where the location is
    if (map.getZoom() > 13) {
      return map.setZoom(13);
    }
  }

  hidePOI() {
    // Hide Google POIs to reduce clutter
    return this.mapObject.setOptions({
      styles: [
        {
          featureType: "poi",
          stylers: [{ visibility: "off" }],
        },
      ],
    });
  }

  createInfoWindow(marker, content) {
    const infoWindow = new google.maps.InfoWindow({ content });
    return this.displayInfoWindowOnClick(marker, infoWindow);
  }

  displayInfoWindowOnClick(marker, infoWindow) {
    return google.maps.event.addListener(marker, "click", () => {
      if (this.infoWindow) {
        this.infoWindow.close();
      }
      this.infoWindow = infoWindow;
      return infoWindow.open(this.mapObject, marker);
    });
  }

  infoWindowTemplate(location) {
    let tmpl = "";
    if (location.thumbnail) {
      tmpl += "<figure class='iw-image'><img src='" + location.thumbnail + "'></figure>";
      tmpl += "<div class='iw-content iw-thumbnail-present'>";
    } else {
      tmpl += "<div class='iw-content'>";
    }
    const address = location.addresses[0];
    if (address.heading) {
      if (address.heading_url) {
        tmpl +=
          "<div class='iw-heading'><a href='" +
          _.escape(address.heading_url) +
          "'>" +
          _.escape(address.heading) +
          "</a></div>";
      } else {
        tmpl += "<div class='iw-heading'>" + _.escape(address.heading) + "</div>";
      }
    }
    tmpl += "<div class='iw-address'>";
    tmpl += address.first_line + "<br>";
    if (address.second_line) {
      tmpl += address.second_line + "<br>";
    }
    tmpl += address.city + ", " + address.state;
    if (address.phone) {
      tmpl += "<br>" + address.phone;
    }
    tmpl += "</div>";
    tmpl +=
      "<a href=" +
      address.directions_url +
      ` target='_blank'><i class='icon-directions-outlined'></i> ${this.I18n.directions}</a></div>`;
    return tmpl;
  }
};
